import { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';

export const EditPaymentMethodSkeleton: FC = () => {
	return (
		<Stack gap={2}>
			{/* "Selected payment method" heading */}
			<Skeleton variant="rounded" width="60%" height={24} animation="pulse" />

			{/* Card list item skeleton */}
			<Stack
				direction="row"
				alignItems="center"
				gap={1.5}
				sx={{
					border: (theme) => `1px solid ${theme.palette.neutral[40]}`,
					borderRadius: 2,
					px: 1.5,
					py: 1.5,
				}}
			>
				{/* Left icon */}
				<Skeleton variant="rounded" width={32} height={32} animation="pulse" />

				{/* Text content */}
				<Stack gap={0.5} sx={{ flex: 1 }}>
					<Skeleton
						variant="rounded"
						width="20%"
						height={16}
						animation="pulse"
					/>
					<Skeleton
						variant="rounded"
						width="50%"
						height={12}
						animation="pulse"
					/>
				</Stack>

				{/* Right edit icon */}
				<Skeleton variant="rounded" width={20} height={20} animation="pulse" />
			</Stack>
		</Stack>
	);
};
